var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { EventConstants } from "../../constants";
import { Column, COLUMN_EVENTS } from "./column";
import { submitColumnSettings } from "./ajax";
import { fadeIn, scrollToElement } from "../../helpers/animations";
import { insertAfter } from "../../helpers/elements";
import { uniqid } from "../../helpers/string";
var Form = /** @class */ (function () {
    function Form(element, events) {
        this.form = element;
        this.events = events;
        this.columns = [];
        this.events.emit(EventConstants.SETTINGS.FORM.LOADED, this);
        this.init();
    }
    Form.prototype.init = function () {
        this.initColumns();
        if (this.isDisabled()) {
            this.disableFields();
            this.disableColumns();
        }
        this.events.emit(EventConstants.SETTINGS.FORM.READY, this);
    };
    Form.prototype.getElement = function () {
        return this.form;
    };
    Form.prototype.getColumns = function () {
        return this.columns;
    };
    Form.prototype.getSortedColumns = function () {
        var _this = this;
        var result = [];
        this.getElement().querySelectorAll('form.ac-column').forEach(function (column) {
            var c = _this.columns.find(function (c) { return c.getName() === column.dataset.columnName; });
            if (c) {
                result.push(c);
            }
        });
        return result;
    };
    Form.prototype.placeColumn = function (column, after) {
        if (after === void 0) { after = null; }
        if (after) {
            insertAfter(column.getElement(), after);
        }
        else {
            this.getElement().querySelector('.ac-columns').append(column.getElement());
        }
        setTimeout(function () {
            scrollToElement(column.getElement(), 300, { offset: -18 });
        }, 300);
        return this;
    };
    Form.prototype.createNewColumn = function () {
        var column = createColumnFromTemplate();
        this.columns.push(column);
        this.placeColumn(column);
        this.bindColumnEvents(column);
        column.open(300);
        return column;
    };
    Form.prototype.isDisabled = function () {
        return this.form.classList.contains('-disabled');
    };
    Form.prototype.getOriginalColumns = function () {
        return this.columns.filter(function (column) { return column.isOriginal(); });
    };
    Form.prototype.disableColumns = function () {
        this.columns.forEach(function (col) { return col.disable(); });
    };
    Form.prototype.initColumns = function () {
        var _this = this;
        this.getElement().querySelectorAll('.ac-column').forEach(function (element) {
            var column = new Column(element, element.dataset.columnName);
            _this.columns.push(column);
            _this.bindColumnEvents(column);
        });
    };
    Form.prototype.bindColumnEvents = function (column) {
        var _this = this;
        column.events.addListener(COLUMN_EVENTS.REMOVE, function () {
            _this.removeColumn(column.getName());
        });
        column.events.addListener(COLUMN_EVENTS.CLONE, function () {
            var cloneColumn = new Column(column.getElement().cloneNode(true), uniqid());
            _this.columns.push(cloneColumn);
            _this.placeColumn(cloneColumn, column.getElement()).bindColumnEvents(cloneColumn);
            column.isOpen() ? cloneColumn.open() : cloneColumn.close();
            fadeIn(cloneColumn.getElement(), 300);
        });
    };
    Form.prototype.resetColumns = function () {
        this.columns.forEach(function (column) {
            column.destroy();
        });
        this.columns = [];
    };
    Form.prototype.getFormData = function () {
        var columnData = {};
        var titleElement = this.getElement().querySelector('input[name=title]');
        this.getSortedColumns().forEach(function (column) {
            columnData[column.getName()] = column.getJson();
        });
        return {
            title: titleElement ? titleElement.value : '',
            list_screen: AC.list_screen,
            list_screen_id: AC.layout,
            columns: columnData,
            settings: this.getPreferences()
        };
    };
    Form.prototype.disableFields = function () {
        this.getElement().querySelectorAll('input, select, button').forEach(function (el) {
            el.setAttribute('readonly', 'readonly');
            el.setAttribute('disabled', 'disabled');
        });
    };
    Form.prototype.submitForm = function () {
        var _this = this;
        this.events.emit(EventConstants.SETTINGS.FORM.SAVING, this);
        submitColumnSettings(this.getFormData()).then(function (response) {
            if (response.data.success) {
                _this.showMessage(response.data.data, 'updated');
            }
            else if (response.data) {
                var error = response.data;
                _this.showMessage(error.data.message, 'notice notice-warning');
            }
        }).catch(function () {
            _this.showMessage(AC.i18n.error.save_settings);
        }).finally(function () {
            _this.events.emit(EventConstants.SETTINGS.FORM.SAVED, _this);
        });
    };
    Form.prototype.showMessage = function (message, className) {
        var _a;
        if (className === void 0) { className = 'updated'; }
        var messageContainer = document.querySelector('.ac-admin__main');
        messageContainer.querySelectorAll('.ac-message').forEach(function (el) { return el.remove(); });
        var element = document.createElement('div');
        element.classList.add('ac-message');
        (_a = element.classList).add.apply(_a, __spread(className.split(' ')));
        element.innerHTML = "<p>" + message + "</p>";
        messageContainer.insertAdjacentElement('afterbegin', element);
        fadeIn(element, 600);
    };
    Form.prototype.removeColumn = function (name) {
        var _this = this;
        this.columns.forEach(function (c, i) {
            if (name === c.getName()) {
                _this.columns.splice(i, 1);
            }
        });
    };
    Form.prototype.getPreferences = function () {
        var data = {};
        document.querySelectorAll('form[data-form-part=preferences]').forEach(function (el) {
            var e_1, _a;
            var fData = new FormData(el);
            try {
                // @ts-ignore
                for (var _b = __values(fData.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var entry = _c.value;
                    var key = entry[0];
                    var value = entry[1];
                    var element = el.elements[key];
                    data[key] = element.tagName === 'SELECT' && element.hasAttribute('multiple')
                        ? fData.getAll(key)
                        : data[key] = value;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        });
        return data;
    };
    return Form;
}());
export { Form };
var createColumnFromTemplate = function () {
    var columnElement = document.querySelector('#add-new-column-template .ac-column').cloneNode(true);
    var newColumnName = uniqid();
    columnElement.querySelectorAll('label[for]').forEach(function (label) {
        var relatedId = label.getAttribute('for');
        if (relatedId) {
            var relatedElement = columnElement.querySelector("#" + relatedId);
            if (relatedElement) {
                var newID = relatedId + newColumnName;
                label.setAttribute('for', newID);
                relatedElement.id = newID;
            }
        }
    });
    return new Column(columnElement, newColumnName);
};
